module.exports = __webpack_public_path__ + "img/CG1_62.a0fb87f.png";